 import { v4 as uuid } from 'uuid';

export class SgvId {
  static gen(): string {
    return new SgvId().value;
  }
  constructor(public readonly value = uuid()) {} 
}
